import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import CloseButton from "@/ts/components/elements/close-button.vue";
import { useEventBus } from "@vueuse/core";
import { useScrollLock } from "@vueuse/core";

interface Props {
    show: boolean;
    showClose?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'slideout',
  props: {
    show: { type: Boolean, required: true },
    showClose: { type: Boolean, required: false, default: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const bus = useEventBus<string>("hamburger");

const slideout = ref<HTMLElement | null>(null);
const body = ref<HTMLElement>(document.body);

const bodyScrollLocked = useScrollLock(body);

const props = __props;

watch(
    () => props.show,
    (show) => {
        if (show === false) {
            bus.emit("hamburger-close");
            bodyScrollLocked.value = false;
        } else {
            bodyScrollLocked.value = true;
        }
    },
);

const __returned__ = { bus, slideout, body, bodyScrollLocked, props, CloseButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})